//:: AUTH
export const AUTH_SET_USER_ID = 'AUTH_SET_USER_ID'
export const AUTH_SET_EMAIL = 'AUTH_SET_EMAIL'
export const AUTH_SET_ACCESS_TOKEN = 'AUTH_SET_ACCESS_TOKEN'
export const AUTH_SET_ACCESS_SESSION = 'AUTH_SET_ACCESS_SESSION'
export const AUTH_SET_REFRESH_TOKEN = 'AUTH_SET_REFRESH_TOKEN'
export const AUTH_SET_EXPIRY = 'AUTH_SET_EXPIRY'
export const AUTH_SET_CUSTOMER_ID = 'AUTH_SET_CUSTOMER_ID'
export const AUTH_SET_CUSTOMER_NAME = 'AUTH_SET_CUSTOMER_NAME'
export const AUTH_SET_CUSTOMER_CONTACT_ID = 'AUTH_SET_CUSTOMER_CONTACT_ID'
export const AUTH_SET_CUSTOMER_CONTACT_NAME = 'AUTH_SET_CUSTOMER_CONTACT_NAME'
export const AUTH_SET_STATUS = 'AUTH_SET_STATUS'
export const AUTH_SET_ERROR = 'AUTH_SET_ERROR'
export const AUTH_SET_ROLE = 'AUTH_SET_ROLE'
export const AUTH_SET_USER_LAST_UPDATE = 'AUTH_SET_USER_LAST_UPDATE'
export const AUTH_SET_CUSTOMER_LAST_UPDATE = 'AUTH_SET_CUSTOMER_LAST_UPDATE'
export const AUTH_SET_WELCOME_WATCHED = 'AUTH_SET_WELCOME_WATCHED'
export const AUTH_AUTO_REFRESH = 'AUTH_AUTO_REFRESH'
export const AUTH_CLEAR_AUTO_REFRESH = 'AUTH_CLEAR_AUTO_REFRESH'

//:: ENTITY CACHE
export const SET_FETCH_CACHE = 'SET_FETCH_CACHE'
export const SET_FETCH_CACHE_ITEM = 'SET_FETCH_CACHE_ITEM'
